const getLegCallingPointIndexByNameAndTime = (arriveOrDepart, time, name, tsiLeg) => {
  var _a;
  if (!((_a = tsiLeg == null ? void 0 : tsiLeg.callingPoints) == null ? void 0 : _a.length) || !name) {
    return void 0;
  }
  const { callingPoints } = tsiLeg;
  const ndxSameName = callingPoints.findIndex((c) => {
    var _a2;
    return ((_a2 = c.location) == null ? void 0 : _a2.name) === name;
  });
  if (ndxSameName === void 0) {
    return void 0;
  }
  const ndxSameNameAndTime = arriveOrDepart === "arrive" ? callingPoints.findIndex((c) => {
    var _a2, _b, _c;
    return ((_a2 = c.location) == null ? void 0 : _a2.name) === name && ((_c = (_b = c.arrival) == null ? void 0 : _b.schedule) == null ? void 0 : _c.time) === time;
  }) : arriveOrDepart === "depart" ? callingPoints.findIndex((c) => {
    var _a2, _b, _c;
    return ((_a2 = c.location) == null ? void 0 : _a2.name) === name && ((_c = (_b = c.departure) == null ? void 0 : _b.schedule) == null ? void 0 : _c.time) === time;
  }) : -1;
  const ndx = ndxSameNameAndTime >= 0 ? ndxSameNameAndTime : ndxSameName >= 0 ? ndxSameName : void 0;
  return ndx;
};
var getLegCallingPointIndexByNameAndTime_default = getLegCallingPointIndexByNameAndTime;
export {
  getLegCallingPointIndexByNameAndTime_default as default
};
